var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.5C14.96 21.5 12.5 19.04 12.5 16C12.5 12.96 14.96 10.5 18 10.5C21.04 10.5 23.5 12.96 23.5 16C23.5 19.04 21.04 21.5 18 21.5ZM18 13.5C16.62 13.5 15.5 14.62 15.5 16C15.5 17.38 16.62 18.5 18 18.5C19.38 18.5 20.5 17.38 20.5 16C20.5 14.62 19.38 13.5 18 13.5Z",
    fill: "#D0D5DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45.5H18C7.14 45.5 2.5 40.86 2.5 30V18C2.5 7.14 7.14 2.5 18 2.5H26C26.82 2.5 27.5 3.18 27.5 4C27.5 4.82 26.82 5.5 26 5.5H18C8.78 5.5 5.5 8.78 5.5 18V30C5.5 39.22 8.78 42.5 18 42.5H30C39.22 42.5 42.5 39.22 42.5 30V20C42.5 19.18 43.18 18.5 44 18.5C44.82 18.5 45.5 19.18 45.5 20V30C45.5 40.86 40.86 45.5 30 45.5Z",
    fill: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.12 15.38C32.74 15.38 32.36 15.24 32.06 14.94C31.48 14.36 31.48 13.4 32.06 12.82L39.84 5.04001C40.42 4.46001 41.38 4.46001 41.96 5.04001C42.54 5.62001 42.54 6.58001 41.96 7.16001L34.18 14.94C33.88 15.24 33.5 15.38 33.12 15.38Z",
    fill: "#D0D5DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.88 15.38C40.5 15.38 40.12 15.24 39.82 14.94L32.04 7.16001C31.46 6.58001 31.46 5.62001 32.04 5.04001C32.62 4.46001 33.58 4.46001 34.16 5.04001L41.94 12.82C42.52 13.4 42.52 14.36 41.94 14.94C41.66 15.24 41.28 15.38 40.88 15.38Z",
    fill: "#D0D5DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3401 39.4C4.8601 39.4 4.3801 39.16 4.1001 38.74C3.6401 38.06 3.8201 37.12 4.5001 36.66L14.3601 30.04C16.5201 28.6 19.5001 28.76 21.4601 30.42L22.1201 31C23.1201 31.86 24.8201 31.86 25.8001 31L34.1201 23.86C36.2401 22.04 39.5801 22.04 41.7201 23.86L44.9801 26.66C45.6001 27.2 45.6801 28.14 45.1401 28.78C44.6001 29.4 43.6601 29.48 43.0201 28.94L39.7601 26.14C38.7601 25.28 37.0601 25.28 36.0801 26.14L27.7601 33.28C25.6401 35.1 22.3001 35.1 20.1601 33.28L19.5001 32.7C18.5801 31.92 17.0601 31.84 16.0401 32.54L6.2001 39.16C5.9201 39.32 5.6201 39.4 5.3401 39.4Z",
    fill: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryRemove);
export default __webpack_public_path__ + "5c8022ec277b2233442eb7fac77830e1.svg";
export { ForwardRef as ReactComponent };